import "./Footer.css";
import logo from "../assets/images/Logo white.svg";
import { ReactComponent as Email } from "../assets/images/mail1.svg";
import { ReactComponent as Location } from "../assets/images/location1.svg";
import { ReactComponent as Phone } from "../assets/images/phone-call1.svg";
import { ReactComponent as Linkedin } from "../assets/images/LinkedIn-icon.svg";
import { ReactComponent as Facebook } from "../assets/images/Facebook-icon.svg";
import { ReactComponent as Instagram } from "../assets/images/Instagram-icon.svg";
import { ReactComponent as Whatsapp } from "../assets/images/WhatsApp-icon.svg";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
function Footer() {
  return (
    <>
      <div className="footer ">
        <div className="container">
          <Row>
            <div className="d-flex container justify-content-around flex-wrap text-center text-sm-start gap-3 gap-md-3 gap-sm-0 ">
              <Col lg={3} md={12} sm={12}>
                <div className="footer-logo">
                  <Link to="/" ><img src={logo} alt="" style={{ height: "70px" }} /></Link> 
                  <p className="mt-4 p" style={{ fontSize: "16px" }}>
                    Flora infotech offers web & mobile development solution for
                    all industry verticals.
                  </p>
                  <div className="mb-3 d-flex gap-3 mx-auto">
                    <div className="social-div">
                      <Link
                        to="https://www.linkedin.com/in/flora-infotech-998292360?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                        className="nav-link"
                      >
                        <Linkedin
                          style={{
                            height: "40px",
                            width: "40px",
                          }}
                        />
                      </Link>
                    </div>
                    <div className="social-div">
                      <Link
                        to="https://www.facebook.com/flora.infotech.2025"
                        className="nav-link"
                      >
                        <Facebook
                          style={{
                            height: "40px",
                            width: "40px",
                          }}
                        />
                      </Link>
                    </div>
                    <div className="social-div">
                      <Link
                        to="https://www.instagram.com/flora_infotech/"
                        className="nav-link"
                      >
                        <Instagram
                          style={{
                            height: "40px",
                            width: "40px",
                          }}
                        />
                      </Link>
                    </div>
                    <div className="social-div">
                      <Link
                        to="https://wa.me/+919274448139"
                        className="nav-link"
                      >
                        <Whatsapp
                          style={{
                            height: "40px",
                            width: "40px",
                          }}
                        />{" "}
                      </Link>
                    </div>
                  </div>
                </div>
              </Col>
              <div>
                <h4 className="heading">Important Link</h4>
                <ul className="mt">
                  <div className="d-flex flex-column gap">
                    <li>
                      <Link to="/" className="nav-link">
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link to="/about" className="nav-link">
                        About Us
                      </Link>
                    </li>
                    <li>
                      <Link to="/services" className="nav-link">
                        Services
                      </Link>
                    </li>
                    <li>
                      <Link to="/contact" className="nav-link">
                        Contact Us
                      </Link>
                    </li>
                  </div>
                </ul>
              </div>
              <div>
                <h4 className="heading">Our Services</h4>
                <ul className="mt">
                  <div className="d-flex flex-column gap">
                    <li>
                      <Link to="/services" className="nav-link">
                        Web Development{" "}
                      </Link>
                    </li>
                    <li>
                      <Link to="/services" className="nav-link">
                        Mobile App Development{" "}
                      </Link>
                    </li>
                    <li>
                      <Link to="/services" className="nav-link">
                        Web Design{" "}
                      </Link>
                    </li>
                  </div>
                </ul>
              </div>
              <div>
                <h4 className="heading ">Contact Info</h4>
                <div className="d-flex flex-column gap mt">
                  <div className="d-flex gap-3 gap-sm-4">
                    <Location style={{}} />
                    <p className="text-start p mb-0">
                      204, Blue Stone Building, <br /> Shyamdham Chowk, Surat,
                      Gujarat.
                    </p>
                  </div>

                  <div className="d-flex gap-3 gap-sm-4 ">
                    <Phone />
                    <p className="p mb-0">+91 92744 48139</p>
                  </div>
                  <div className="d-flex gap-4 gap-sm-4">
                    <Email
                      style={{ }}
                    />
                    <p className="text-start p mb-0">contact@flora-infotech.com</p>
                  </div>
                </div>
              </div>
            </div>
          </Row>
          {/* <div className="text-center p-3 d-flex justify-content-center gap-4">
          <div className="social-div">
            <Link
              to="https://www.linkedin.com/in/flora-infotech-998292360?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
              className="nav-link"
            >
              <Linkedin
                style={{ height: "25px", width: "25px", fill: "white" }}
              />
            </Link>
          </div>
          <div className="social-div">
            <Link
              to="https://www.facebook.com/flora.infotech.2025"
              className="nav-link"
            >
              <Facebook
                style={{ height: "26px", width: "26px", fill: "white" }}
              />
            </Link>
          </div>
          <div className="social-div">
            <Link
              to="https://www.instagram.com/flora_infotech/"
              className="nav-link"
            >
              <Instagram
                style={{
                  height: "25px",
                  width: "25px",
                  fill: "white",
                  stroke: "white",
                }}
              />
            </Link>
          </div>
          <div className="social-div">
            <Link to="https://wa.me/+919274448139" className="nav-link">
              <Whatsapp
                style={{
                  height: "27px",
                  width: "27px",
                  fill: "white",
                  stroke: "white",
                }}
              />{" "}
            </Link>
          </div>
        </div> */}
          <hr className="container mt-5" />
          <div>
            <p className="text-center p-2 p">
              Copyright © 2025 Flora Infotech. All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
